export default '/:\DevWork\clio\packages\playground'